import {
  Box,
  Button,
  Grid,
  TextField,
  Typography
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid";
import { useState, useEffect } from "react";
import { useFetcher } from "react-router-dom";

const getDetailGridProps = ({ value, updated_at }) => {
  const totalCount = value?.length || 0
  const badgeState = totalCount > 0 ? "checked" : "unchecked"

  const props = {
    badgeState,
    columns: [
      { title: "Total Countries", description: totalCount },
      { title: "Last Modified", description:  updated_at || "-" }
    ]
  }

  return props
}

const GlobalAllowedCountriesForm = ({ value, onCancel }) => {
  const fetcher = useFetcher()
  const errors = fetcher.data?.errors || {}
  const [countries, setCountries] = useState(value === ""  ? value : (value?.join(",") ?? ""))
  const handleSubmit = (e) => {
    fetcher.submit(
      { name: "allowed_countries", value: countries },
      { method: "post" }
    )
  }

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data) {
      const updateFailed = "errors" in fetcher.data

      if (!updateFailed) {
        onCancel()
      }
    }
  }, [fetcher, onCancel])

  return (
    <Grid container item>
      <Grid item xs={12}>
        <TextField
          name="value"
          multiline
          fullWidth
          onChange={(e) => setCountries(e.target.value)}
          error={"value" in errors}
          helperText={errors["value"]}
          value={countries}
          minRows={4}
        />
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            float: "right",
            mt: 2
          }}
        >
          <Button variant="contained" size="small" sx={{ mr: 1 }} onClick={handleSubmit}>Save</Button>
          <Button size="small" onClick={onCancel}>Cancel</Button>
        </Box>
      </Grid>
    </Grid>
  );
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const GlobalAllowedCountriesSection = ({ value, updated_at }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = (event) => setIsEditing((prev) => !prev);

  return (
    <Section title={"Global Allowed Countries List"} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ mb: 2.5 }}>
          <Typography variant="subtitle1" color="rgb(0,0,0,0.60)">Allowed Countries</Typography>
        </Grid>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          {isEditing ? (
            <GlobalAllowedCountriesForm value={value} onCancel={handleEditClick} />
          ) : (
            <DetailGrid
              {...getDetailGridProps({ value, updated_at })}
            />
          )} 
        </Grid>
      </Grid>
    </Section>
  )
}

export default GlobalAllowedCountriesSection;
